// 支持通过环境变量配置 API 地址
// 开发环境: VITE_API_HOST=http://localhost:8081
// 生产环境: VITE_API_HOST=https://your-production-api.com
export const API_HOST = import.meta.env.VITE_API_HOST || "http://localhost:8081"
// export const API_HOST = "http://47.108.203.255:8081"
// export const API_HOST = "http://8.137.87.125:8082"
// export const API_HOST = "http://104.194.85.223:8081"